export default __webpack_public_path__ + "media/zurb/img/services/tools/sketching-screenshot2-94b8cad504c68f6972bfef4836ccf7fe.png";